import {Pipe, PipeTransform} from '@angular/core';
import {filtersToQuerySkipProperties} from '@shared/constants/filters-to-query.constants';

@Pipe({
  name: 'filtersToQuery'
})
export class FiltersToQueryPipe implements PipeTransform {
  /**
 * As the reference to 'filters' does not change, the pipe will not be executed any more.
 * The variable 'resetPipe' is used to make the pipe recalculate the result.
 */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(filters: Record<string, any>, resetPipe?: number): string {
    let cleanedFilters = {};
    for (const [key, value] of Object.entries(filters)) {
      // Omit empty properties
      if (!(value?.code || value)) {
        continue;
      }

      // Omit skipped properties
      if (filtersToQuerySkipProperties.includes(key)) {
        continue;
      }

      // Get value (or code when IdName)
      cleanedFilters[key] = value?.code || value;
    }

    // Return if empty
    if (!Object.keys(cleanedFilters).length) {
      return '';
    }

    // Get a query string suitable for use in a URL
    const queryParams = new URLSearchParams(cleanedFilters);
    return `?${queryParams.toString()}`;
  }
}
